/* ============================================
   Bushnell Golf Theme - JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', function() {

  /* --- Mobile Drawer --- */
  var drawer = document.querySelector('[data-mobile-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeBtn = document.querySelector('[data-drawer-close]');

  function openDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.add('mobile-drawer--open');
    overlay.classList.add('mobile-overlay--open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer || !overlay) return;
    drawer.classList.remove('mobile-drawer--open');
    overlay.classList.remove('mobile-overlay--open');
    document.body.style.overflow = '';
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* --- Mega Menu (Desktop) ---
     Mechanics: 120ms intent delay on first open (instant switching once a
     panel is already open), 250ms close grace so diagonal cursor paths
     don't flicker, Esc + click-outside close, and tap-once-to-open on
     touch (first tap opens the panel, second tap follows the link). */
  var megaNav = document.querySelector('[data-mega-nav]');
  var megaOpenTimer = null;
  var megaCloseTimer = null;
  var MEGA_OPEN_DELAY = 120;
  var MEGA_CLOSE_GRACE = 250;

  function megaClearTimers() {
    if (megaOpenTimer) { clearTimeout(megaOpenTimer); megaOpenTimer = null; }
    if (megaCloseTimer) { clearTimeout(megaCloseTimer); megaCloseTimer = null; }
  }

  function anyMegaPanelOpen() {
    return !!document.querySelector('[data-mega-panel]:not([hidden])');
  }

  function showMegaPanel(handle) {
    document.querySelectorAll('[data-mega-panel]').forEach(function(p) { p.hidden = true; });
    document.querySelectorAll('[data-mega-trigger]').forEach(function(t) { t.classList.remove('mega-active'); });
    var panel = document.querySelector('[data-mega-panel="' + handle + '"]');
    var trigger = document.querySelector('[data-mega-trigger="' + handle + '"]');
    if (panel) panel.hidden = false;
    if (trigger) trigger.classList.add('mega-active');
  }

  function hideAllMegaPanels() {
    megaClearTimers();
    document.querySelectorAll('[data-mega-panel]').forEach(function(p) { p.hidden = true; });
    document.querySelectorAll('[data-mega-trigger]').forEach(function(t) { t.classList.remove('mega-active'); });
  }

  function scheduleClose() {
    if (megaCloseTimer) clearTimeout(megaCloseTimer);
    megaCloseTimer = setTimeout(hideAllMegaPanels, MEGA_CLOSE_GRACE);
  }

  document.querySelectorAll('[data-mega-trigger]').forEach(function(trigger) {
    var handle = trigger.getAttribute('data-mega-trigger');

    trigger.addEventListener('mouseenter', function() {
      megaClearTimers();
      if (anyMegaPanelOpen()) {
        showMegaPanel(handle); /* already browsing: switch instantly */
      } else {
        megaOpenTimer = setTimeout(function() { showMegaPanel(handle); }, MEGA_OPEN_DELAY);
      }
    });

    trigger.addEventListener('mouseleave', function() {
      if (megaOpenTimer) { clearTimeout(megaOpenTimer); megaOpenTimer = null; }
      scheduleClose();
    });

    /* Touch: first tap opens the panel instead of navigating; second tap
       (panel already open for this trigger) follows the link. */
    var link = trigger.querySelector('a');
    if (link) {
      link.addEventListener('click', function(e) {
        var isTouch = window.matchMedia('(hover: none)').matches;
        if (!isTouch) return;
        var panel = document.querySelector('[data-mega-panel="' + handle + '"]');
        if (panel && panel.hidden) {
          e.preventDefault();
          megaClearTimers();
          showMegaPanel(handle);
        }
      });
    }
  });

  document.querySelectorAll('[data-mega-panel]').forEach(function(panel) {
    panel.addEventListener('mouseenter', megaClearTimers);
    panel.addEventListener('mouseleave', scheduleClose);
  });

  if (megaNav) {
    megaNav.addEventListener('mouseleave', scheduleClose);
  }

  /* Click/tap outside the nav closes any open panel */
  document.addEventListener('click', function(e) {
    if (!anyMegaPanelOpen()) return;
    if (megaNav && megaNav.contains(e.target)) return;
    hideAllMegaPanels();
  }, true);

  /* --- Mobile Accordion --- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var panel = this.nextElementSibling;
      var isOpen = !panel.hidden;
      // Close all
      document.querySelectorAll('.mobile-accordion-panel').forEach(function(p) { p.hidden = true; });
      document.querySelectorAll('.mobile-accordion-trigger').forEach(function(t) {
        t.classList.remove('mobile-accordion-trigger--open');
        var svg = t.querySelector('svg polyline');
        if (svg) svg.setAttribute('points', '6 9 12 15 18 9');
      });
      // Toggle current
      if (!isOpen) {
        panel.hidden = false;
        this.classList.add('mobile-accordion-trigger--open');
        var svg = this.querySelector('svg polyline');
        if (svg) svg.setAttribute('points', '18 15 12 9 6 15');
      }
    });
  });

  /* --- PDP Tabs --- */
  document.querySelectorAll('[data-tab]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = this.getAttribute('data-tab');
      // Deactivate all
      document.querySelectorAll('.pdp-tab-btn').forEach(function(b) { b.classList.remove('pdp-tab-btn--active'); });
      document.querySelectorAll('[data-tab-panel]').forEach(function(p) { p.hidden = true; });
      // Activate target
      this.classList.add('pdp-tab-btn--active');
      var panel = document.querySelector('[data-tab-panel="' + target + '"]');
      if (panel) panel.hidden = false;
    });
  });

  /* --- PDP Scrollable Gallery --- */
  var pdpScroll = document.querySelector('[data-pdp-scroll]');
  var pdpThumbs = document.querySelectorAll('[data-pdp-thumbs] .pdp-thumb');
  var pdpDots = document.querySelectorAll('[data-pdp-dots] .pdp-scroll-dot');

  function scrollToSlide(index) {
    if (!pdpScroll) return;
    var slides = pdpScroll.querySelectorAll('.pdp-scroll-slide');
    if (slides[index]) {
      slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
    pdpThumbs.forEach(function(t) { t.classList.remove('pdp-thumb--active'); });
    pdpDots.forEach(function(d) { d.classList.remove('pdp-scroll-dot--active'); });
    if (pdpThumbs[index]) pdpThumbs[index].classList.add('pdp-thumb--active');
    if (pdpDots[index]) pdpDots[index].classList.add('pdp-scroll-dot--active');
  }

  pdpThumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      scrollToSlide(parseInt(this.getAttribute('data-thumb-index')));
    });
  });

  pdpDots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      scrollToSlide(parseInt(this.getAttribute('data-dot-index')));
    });
  });

  // Sync dots/thumbs on scroll
  if (pdpScroll) {
    var scrollTimer = null;
    pdpScroll.addEventListener('scroll', function() {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var slideWidth = pdpScroll.offsetWidth;
        var currentIndex = Math.round(pdpScroll.scrollLeft / slideWidth);
        pdpThumbs.forEach(function(t) { t.classList.remove('pdp-thumb--active'); });
        pdpDots.forEach(function(d) { d.classList.remove('pdp-scroll-dot--active'); });
        if (pdpThumbs[currentIndex]) pdpThumbs[currentIndex].classList.add('pdp-thumb--active');
        if (pdpDots[currentIndex]) pdpDots[currentIndex].classList.add('pdp-scroll-dot--active');
      }, 50);
    }, { passive: true });
  }

  /* --- PLP Card Gallery (horizontal scroll with dots) --- */
  document.querySelectorAll('[data-card-gallery]').forEach(function(gallery) {
    var track = gallery.querySelector('[data-card-gallery-track]');
    var dots = gallery.querySelectorAll('[data-gallery-dot]');
    if (!track) return;

    track.addEventListener('scroll', function() {
      var slideWidth = track.offsetWidth;
      var currentIndex = Math.round(track.scrollLeft / slideWidth);
      dots.forEach(function(d) { d.classList.remove('p-card-gallery-dot--active'); });
      if (dots[currentIndex]) dots[currentIndex].classList.add('p-card-gallery-dot--active');
    }, { passive: true });
  });

  /* --- Sort Select (Collection) --- */
  var sortSelect = document.getElementById('plpSortSelect');
  if (sortSelect) {
    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* --- Search Overlay --- */
  var searchOverlay = document.querySelector('[data-search-overlay]');
  var searchBackdrop = document.querySelector('[data-search-backdrop]');
  var searchToggleBtn = document.querySelector('[data-search-toggle]');
  var searchCloseBtn = document.querySelector('[data-search-close]');

  function openSearch() {
    if (!searchOverlay || !searchBackdrop) return;
    searchOverlay.classList.add('search-overlay--open');
    searchBackdrop.classList.add('search-overlay-backdrop--open');
    var input = searchOverlay.querySelector('.search-overlay-input');
    if (input) setTimeout(function() { input.focus(); }, 300);
    document.body.style.overflow = 'hidden';
  }
  function closeSearch() {
    if (!searchOverlay || !searchBackdrop) return;
    searchOverlay.classList.remove('search-overlay--open');
    searchBackdrop.classList.remove('search-overlay-backdrop--open');
    document.body.style.overflow = '';
  }

  if (searchToggleBtn) searchToggleBtn.addEventListener('click', openSearch);
  if (searchCloseBtn) searchCloseBtn.addEventListener('click', closeSearch);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeSearch();
      hideAllMegaPanels();
    }
  });

  /* --- Sticky Header (show on scroll up, hide on scroll down) --- */
  var mainNav = document.querySelector('.main-nav');
  var lastScrollY = 0;
  var scrollThreshold = 10;

  if (mainNav) {
    window.addEventListener('scroll', function() {
      var currentScroll = window.pageYOffset;
      if (currentScroll <= 0) {
        mainNav.classList.remove('main-nav--hidden');
        mainNav.classList.remove('main-nav--scrolled');
        lastScrollY = currentScroll;
        return;
      }
      if (Math.abs(currentScroll - lastScrollY) < scrollThreshold) return;

      if (currentScroll > lastScrollY) {
        // Scrolling down
        mainNav.classList.add('main-nav--hidden');
        hideAllMegaPanels();
      } else {
        // Scrolling up
        mainNav.classList.remove('main-nav--hidden');
      }
      mainNav.classList.toggle('main-nav--scrolled', currentScroll > 60);
      lastScrollY = currentScroll;
    }, { passive: true });
  }

  /* --- Scroll-triggered fade-in animations + lazy loading --- */
  var animatedElements = document.querySelectorAll('.section, .hero, .trust-bar');
  if (animatedElements.length > 0 && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    animatedElements.forEach(function(el) { observer.observe(el); });
  }

  /* --- Lazy-load below-fold sections --- */
  var lazySections = document.querySelectorAll('[data-lazy-section]');
  if (lazySections.length > 0 && 'IntersectionObserver' in window) {
    var lazyObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lazy-loaded');
          // Lazy-load images inside this section
          var lazyImgs = entry.target.querySelectorAll('img[data-src]');
          lazyImgs.forEach(function(img) {
            img.src = img.getAttribute('data-src');
            img.removeAttribute('data-src');
          });
          lazyObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '200px 0px' });

    lazySections.forEach(function(el) { lazyObserver.observe(el); });
  }

});
